// extracted by mini-css-extract-plugin
export default {"whistleWrapper":"MatchInfromation_whistleWrapper__Nauzd","darkWhistleWrapper":"MatchInfromation_darkWhistleWrapper__XSCGW"};